var _a;
import { IndexType as ServerIndexType } from '@api-gen';
import { createDataRecordConverter } from '@core/utils/helpers';
import { IndexType as ClientIndexType } from '@features/guidbooks/types';
export var indexTypeMap = createDataRecordConverter((_a = {},
    _a[ClientIndexType.Rw] = ServerIndexType.Rw,
    _a[ClientIndexType.Lnw] = ServerIndexType.Lnw,
    _a[ClientIndexType.ValueΔRw] = ServerIndexType.ValueΔRw,
    _a));
export var convertToServerIndexTypeData = function (type) {
    return indexTypeMap.toServer[type];
};
export var convertToClientIndexTypeData = function (type) {
    return indexTypeMap.toClient[type];
};
